import React from "react";
import { Pressable } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";

type SmallToggleProps = {
  value: boolean;
  onValueChange: (value: boolean) => void;
  label: string;
  size?: number;
  testID?: string;
};

export function SmallToggle({ value, onValueChange, label, size = 20, testID }: SmallToggleProps) {
  const { colors } = useTheme();

  return (
    <Pressable
      testID={testID}
      style={{ flexDirection: "row", alignItems: "center", gap: 6 }}
      onPress={() => onValueChange(!value)}
    >
      <MaterialCommunityIcons
        name={value ? "checkbox-marked" : "checkbox-blank-outline"}
        size={size}
        color={value ? colors.primary : colors.text}
      />
      <ThemedText style={{ fontSize: 14, opacity: 0.8 }}>{label}</ThemedText>
    </Pressable>
  );
}
